import { timeout } from './utils/timeout';

export async function initNavigation() {
  const ITEM_SWITCH_TIMEOUT = 200;
  const header = document.querySelectorAll('.js-header')[0];
  const navItems = document.querySelectorAll('.menu-item-has-children');
  const testimonialCarousel = header.querySelector('.js-employee_slider');

  // TODO: Optimize, don't init on mobile/tablet devices
  if (!navItems.length || !header) {
    return;
  }

  navItems.forEach((item) => {
    const flyout = item.querySelectorAll('.js-nav_flyout')[0];
    let timerCleanerLeave = null;
    let timerCleanerEnter = null;

    if (!flyout) {
      return;
    }

    item.addEventListener('mouseenter', () => {
      if (timerCleanerLeave) {
        timerCleanerLeave();
      }

      timerCleanerEnter = timeout(() => {
        item.setAttribute('aria-expanded', 'true');
        flyout.setAttribute('aria-hidden', 'false');
        header.classList.add('m-shown_nav');
      }, ITEM_SWITCH_TIMEOUT);
    });

    item.addEventListener('mouseleave', () => {
      if (timerCleanerEnter) {
        timerCleanerEnter();
      }

      timerCleanerLeave = timeout(() => {
        item.setAttribute('aria-expanded', 'false');
        flyout.setAttribute('aria-hidden', 'true');
        header.classList.remove('m-shown_nav');
      }, ITEM_SWITCH_TIMEOUT);
    });
  });

  // !!! It is impossible to use dynamic import in modules (since we use it at the "blocks" level, and cannot use it at two different levels)

  // if (testimonialCarousel) {
  //   const {initSwiperCarousel} = await import("@utils/swiperCarousel");

  //   const options = {
  //     slidesPerView: 1,
  //     pagination: {
  //       el: ".js-swiper-pagination",
  //       clickable: true,
  //     },
  //   };

  //   //js-employee_slider_pagination

  //   initSwiperCarousel(options, testimonialCarousel, true, false, true);
  // }
}
